'use client';

import { api } from '@/lib/api';
import { useQuery } from '@tanstack/react-query';
import { Schedule, ScheduleResponse } from '../types';

/**
 * Fetch schedule details from the API
 * @param scheduleId ID of the schedule to fetch
 */
const fetchSchedule = async (scheduleId: number): Promise<Schedule> => {
  const response = await api.get<ScheduleResponse>(`/v2/schedule/${scheduleId}`);
  return response.data.Data;
};

/**
 * Hook for fetching schedule details
 * @param scheduleId ID of the schedule to fetch
 */
export const useSchedule = (scheduleId: number) => {
  return useQuery<Schedule, Error>({
    queryKey: ['schedule', scheduleId],
    queryFn: () => fetchSchedule(scheduleId),
    enabled: !!scheduleId,
  });
};
